import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGetMarkAnimationSettingParams {
  user: string;
}

export interface IGetMarkAnimationSettingResult extends IResult {
  enabled: boolean;
}
export class GetMarkAnimationSettingRequest extends Request<IGetMarkAnimationSettingParams, IResult> {
  constructor(params: IGetMarkAnimationSettingParams) {
    super('getMarkAnimationEnabledSetting', params);
  }
}
